import React from "react";
import { useTranslation } from "react-i18next";
import GOLoading from "../GOLoading";
import GOError from "../GOError";
import * as Styled from "./styles";
import {
  REQUEST_START,
  REQUEST_FINISH,
  REQUEST_SUCCESS,
  REQUEST_FAILURE
} from "../../../stores/controller/actionTypes";

interface GOAsyncDivProps {
  status: string;
  children: any;
}

const GOAsyncDiv = ({ status, children }: GOAsyncDivProps) => {
  const { t } = useTranslation();
  switch (status) {
    case REQUEST_START:
      return (
        <Styled.AsyncDiv>
          <GOLoading />
        </Styled.AsyncDiv>
      );
    case REQUEST_FINISH:
      return (
        <Styled.AsyncDiv>
          <GOLoading />
        </Styled.AsyncDiv>
      );
    case REQUEST_SUCCESS:
      return <>{children}</>;
    case REQUEST_FAILURE:
      return (
        <>
          <GOError body={t("components.common.serverError")} />
        </>
      );
    default:
      return (
        <>
          <GOError body={t("components.common.serverNetworkError")} />
        </>
      );
  }
};
export default GOAsyncDiv;
